import { mapState as rootMapState } from 'pinia';
import { useUserStore } from '@/store';
import BannerButton from '../../components/banner-button.vue';
import global from '../../common/global';
import { colorBlock } from '../defaultSpacing';
import signLog from '@/components/sign-log';
import util from '@/common/util';
export default {
    i18next: {
        ns: 'md-cta-two-column-single-copy'
    },
    data: function() {
        return {
            sizeOption: {
                type: 'height',
                mobileType: 'height',
                height: 340,
                mobileHeight: 300
            },
            minHeight: '',
            imgLeft: true,
            picture: '',
            mobilePicture: '',
            copyType: 'color',
            copyBackgroundColor: '',
            copyPicture: '',
            copyMobilePicture: '',
            title: '',
            desc: '',
            buttonAlign: 'center',
            buttons: [],
            ...colorBlock
        };
    },
    computed: {
        ...rootMapState(useUserStore, {
            "user": store => store.user
        }),
        isMobile() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobile ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobile ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        usePicture() {
            if (!this.isMobile) {
                return this.picture || this.mobilePicture || '';
            } else {
                return this.mobilePicture || this.picture || '';
            }
        },
        useCopyPicture() {
            if (!this.isMobile) {
                return this.copyPicture || this.copyMobilePicture || '';
            } else {
                return this.copyMobilePicture || this.copyPicture || '';
            }
        }
    },
    mounted() {
        this.currentWidth = window.innerWidth;
        this.calcStyle(true);
        global.resize(this.calcStyle);
    },
    methods: {
        calcStyle(flag) {
            if (
                flag !== true &&
                this.isMobile &&
                this.currentWidth &&
                this.currentWidth === window.innerWidth
            ) {
                return; 
            }
            this.currentWidth = window.innerWidth;
            const sizeOption = this.sizeOption || {};
            let type = sizeOption.type;
            let ratio = sizeOption.ratio;
            let height = sizeOption.height;
            let minHeight = '';
            if (this.isMobile) {
                type = sizeOption.mobileType;
                ratio = sizeOption.mobileRatio;
                height = sizeOption.mobileHeight;
            }
            if (type === 'scale') {
                minHeight =
                    (this.$refs.content.offsetWidth * ratio) / 100 + 'px';
            } else if (type === 'fullScreen') {
                minHeight =
                    Math.max(window.innerHeight - this.$el.offsetTop, 500) +
                    'px';
            } else if (type === 'height') {
                minHeight = height + 'px';
            }
            this.minHeight = minHeight;
        },
        calcRealSize() {
            const sizeOption = this.sizeOption || {};
            let type = sizeOption.type;
            let ratio = sizeOption.ratio;
            let height = sizeOption.height;
            if (this.isMobile) {
                type = sizeOption.mobileType;
                ratio = sizeOption.mobileRatio;
                height = sizeOption.mobileHeight;
            }
            const ele = this.$refs.content;
            if (ele) {
                if (type === 'scale') {
                    ratio = (ele.offsetHeight / ele.offsetWidth) * 100;
                } else if (type === 'height') {
                    height = ele.offsetHeight;
                }
            }
            return {
                type: sizeOption.type,
                mobileType: sizeOption.mobileType,
                ratio: this.isMobile ? sizeOption.ratio : ratio,
                mobileRatio: this.isMobile ? ratio : sizeOption.mobileRatio,
                height: this.isMobile ? sizeOption.height : height,
                mobileHeight: this.isMobile
                    ? height
                    : sizeOption.mobileHeight
            };
        },
        showRegisterPop(action) {
            let role = action?.registerRole || '';
            let tag = action?.tag || '';
            if (!this.user) {
                signLog.register({
                    role,
                    registerData: {
                        tag
                    }
                });
            } else {
                util.toast(
                    this.$t(
                        'md-cta-two-column-single-copy.youAreAlreadyLogged'
                    ),
                    2000
                );
            }
        }
    },
    unmounted() {
        global.resize(this.calcStyle, true);
    },
    components: {
        BannerButton
    }
};
